export default {
    PtCustomFieldLabelPane: {
        fieldMainType: {
            public: '企業自定義字段',
            self: '個人自定義字段',
            shared: '來自分享空間的自定義字段',
        },
        filter: {
            searchFieldPlaceholder: '查找自定義字段',
            noFilterData: '無結果',
            noDataToCreate: '您還沒有自定義字段，<a href="{href}" target="_blank" rel="noopener">現在創建</a>',
            noData: '您還沒有自定義字段',
        },
        render: {
            noData: {
                DATE: '請選擇',
                NUM: '添加',
                LAYER: '請選擇',
                URL: '添加',
                OPTION: '請選擇',
                STRING: '添加',
            },
        },
        editor: {
            placeholder: {
                DATE: '選擇日期',
                NUM: '請輸入數值',
                LAYER: '選擇已有節點',
                URL: '請輸入URL地址',
                OPTION: '選擇已有選項',
                STRING: '請輸入文本',
            },
            validator: {
                NUM: {
                    VALID: '請輸入合法數值',
                },
            },
            filter: {
                OPTION: {
                    noFilterData: '沒有匹配到相關選項',
                    noData: '該字段無選項',
                },
                LAYER: {
                    noFilterData: '沒有匹配到相關節點',
                    noData: '該字段無節點',
                },
            },
        },
        multiLines: {
            more: '更多',
            less: '收起',
        },
        pin: {
            pin: '固定在列表前',
            unPin: '取消固定',
        },
        spaceScopeFieldTip: '標引值僅對當前空間生效',
        spaceScopeEditTip: '非全域自定義欄位僅支持在工作空間內進行標引',
        iconCheck: '校驗AI標引',
        readAsCheck: '修改標引值可完成對 AI 標引的校驗',
    },
};
